import React        from 'react'

export default class DetectionSetting extends React.Component {
  render() {
    return(
      <div>
        <iframe src="https://api.logograb.com/haproxy/" className="haproxy" frameBorder="0" scrolling="auto" title="iframeHAProxy"> You need a browser capable of supporting iframes</iframe>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/HAProxy.js